import { Box, Typography } from '@glplus/glpweb-dsl';
import { RunnerRefreshLink } from './RunnerRefreshLink';
import { runnerTheme, type RunnerTopic } from '../styles/runnerTheme';

export function RunnerPageHeading({ title, subtitle, topic = 'orders', onRefresh, refreshing = false }: {
  title: string; subtitle: string; topic?: RunnerTopic; onRefresh?: () => void; refreshing?: boolean;
}) {
  return <Box sx={{ mb: 1.5 }}>
    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1.5 }}>
      <Typography component="h1" sx={{ fontSize: 28, fontWeight: 700, color: runnerTheme.navy, lineHeight: 1.45, m: 0,
        '&::after': { content: '""', display: 'block', width: 44, height: 3, mt: 1, backgroundColor: runnerTheme.topics[topic].accent } }}>
        {title}
      </Typography>
      {onRefresh && <RunnerRefreshLink onRefresh={onRefresh} refreshing={refreshing} />}
    </Box>
    <Typography sx={{ fontSize: 14, color: runnerTheme.muted, mt: 1.5 }}>{subtitle}</Typography>
  </Box>;
}
